/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeleteUserPaymentMethod200ResponseAllOfData } from './DeleteUserPaymentMethod200ResponseAllOfData';
import {
    DeleteUserPaymentMethod200ResponseAllOfDataFromJSON,
    DeleteUserPaymentMethod200ResponseAllOfDataFromJSONTyped,
    DeleteUserPaymentMethod200ResponseAllOfDataToJSON,
} from './DeleteUserPaymentMethod200ResponseAllOfData';

/**
 * 
 * @export
 * @interface DeleteUserPaymentMethod200Response
 */
export interface DeleteUserPaymentMethod200Response {
    /**
     * 
     * @type {DeleteUserPaymentMethod200ResponseAllOfData}
     * @memberof DeleteUserPaymentMethod200Response
     */
    data: DeleteUserPaymentMethod200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof DeleteUserPaymentMethod200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the DeleteUserPaymentMethod200Response interface.
 */
export function instanceOfDeleteUserPaymentMethod200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function DeleteUserPaymentMethod200ResponseFromJSON(json: any): DeleteUserPaymentMethod200Response {
    return DeleteUserPaymentMethod200ResponseFromJSONTyped(json, false);
}

export function DeleteUserPaymentMethod200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteUserPaymentMethod200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': DeleteUserPaymentMethod200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function DeleteUserPaymentMethod200ResponseToJSON(value?: DeleteUserPaymentMethod200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': DeleteUserPaymentMethod200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

